import React, { Component } from 'react';
import {Link} from "react-router-dom";
import $ from "jquery/dist/jquery.js";

import * as apiConstant from '../../api/apiConstant';

/****************************************
    Component for Top Banner of a page
    @author  IMH003
    @date    2020.05.25
    @version 0.1    
 ******************************************/
class AgencyBlock extends Component {
    constructor(props) {
        super(props);
        this.state = {
          
        };
        this.onErrorImageLoad = this.onErrorImageLoad.bind(this);
    }
    
    componentWillMount() {
    }

    componentDidMount() {  
        
    }
  
    componentDidUpdate() {        
        
    }

    componentWillUnmount() {
    }

    componentWillReceiveProps(newProps) {
    }

    onErrorImageLoad() {
        $('#agency_img_'+this.props.id).attr('src', '');
    }

    render() {

        return (

            <div className="col-12 item text-center">
                <div className="p-4 pb-3">
                    <div className="icon d-flex justify-content-center align-items-center">
                        <Link to={`/agency/${this.props.id}`}>
                            <div className="agency-icon d-flex justify-content-center align-items-center">
                            {
                                this.props.mark_path !== undefined 
                                    && this.props.mark_path !== null 
                                    && this.props.mark_path !== ''
                                    &&
                                <img src={apiConstant.agencyMarkURL(this.props.mark_path)} alt="agency-mark-url" 
                                    id={`#agency_img_${this.props.id}`}
                                    onError={() => this.onErrorImageLoad()}/>
                            }
                            </div>
                        </Link>
                    </div>
                    <div className="text pt-5">
                        <Link to={`/agency/${this.props.id}`} className="title">{this.props.title}</Link>
                    </div>
                </div>
            </div>
        );
    }
}

export default AgencyBlock;
